var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,0H2.5A2.5,2.5,0,0,0,0,2.5v14A2.5,2.5,0,0,0,2.5,19h19A2.5,2.5,0,0,0,24,16.5V2.5A2.5,2.5,0,0,0,21.5,0ZM23,16.5A1.5,1.5,0,0,1,21.5,18H2.5A1.5,1.5,0,0,1,1,16.5V6H23ZM23,5H1V2.5A1.5,1.5,0,0,1,2.5,1h19A1.5,1.5,0,0,1,23,2.5ZM4,2A1,1,0,1,0,5,3,1,1,0,0,0,4,2ZM7,2A1,1,0,1,0,8,3,1,1,0,0,0,7,2Zm3,0a1,1,0,1,0,1,1A1,1,0,0,0,10,2ZM5.15,14.15,7.29,12,5.15,9.85a.49.49,0,0,1,.7-.7l2.5,2.5a.48.48,0,0,1,0,.7l-2.5,2.5a.48.48,0,0,1-.7,0A.48.48,0,0,1,5.15,14.15ZM11,12.5a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,0,1h-4A.5.5,0,0,1,11,12.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechScreen);
export default __webpack_public_path__ + "static/media/tech-screen.92eb9ddfa994148269d054d67b5320b4.svg";
export { ForwardRef as ReactComponent };